import { DialogContent } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useUpdateByPk } from "../../../apollo/networking/use-update-by-pk";
import { useAppDialog } from "../../../app-dialog";
import { CertificateFragment, CertificateModel } from "../../../models/certificate.model";
import { BasicDialogActions } from "../../../ui/dialog";
import { LoadingButton } from "../../../ui/loading-button";
import { CertificateForm } from "./certificate.form";
import { CertificateInitialValues, CertificateValidationSchema } from "./certificate.validation";


type Props = {
    item: CertificateModel;
    onFinish: (product: CertificateModel) => void;
}

export const CertificateEdit = ({
    onFinish,
    item,
}: Props) => {
    const {
        onUpdate,
        loading,
    } = useUpdateByPk({
        entity_name: 'certificate',
        pk_columns: [{
            name: 'id',
            type: 'bigint',
            value: item.id,
        }],
        fragment: CertificateFragment,
    });

    const app_dialog = useAppDialog();

    const onSubmit = async (values: any) => {
        try {
            const result = await onUpdate({
                ...values,
            }) as CertificateModel;
            if (!!result) {
                onFinish(result);
            }
        } catch (e: any) {
            app_dialog.showError(e);
        }
    }
    return <Formik initialValues={CertificateInitialValues(item)}
        validationSchema={CertificateValidationSchema}
        onSubmit={onSubmit}>{() => <Form noValidate>
            <DialogContent>
                <CertificateForm />
            </DialogContent>
            <BasicDialogActions>
                <LoadingButton loading={loading}
                    color='primary'
                    size='large'
                    type='submit'
                    variant='contained'>
                    Save
                </LoadingButton>
            </BasicDialogActions>
        </Form>}
    </Formik>
}
